<sm-sidebar-item [item]="item" [showDot]="showDot$ | async"></sm-sidebar-item>
